import axios from 'axios';
import store from '@/store';
import { MessageBox, Message } from 'element-ui';
import router from '../router';
// import  https  from 'https';
// import * as https from 'https';

//https://stackoverflow.com/questions/68239942/using-https-with-axios-request-in-nestjs

//console.log("env",process.env);
let start = "";
let surl = "";
const service = axios.create({
  //baseURL: process.env.VUE_APP_BASE_API,
  timeout: 120000,
  // baseURL: "https://35.236.134.72/",
  baseURL: process.env.VUE_APP_BASE_API,
  // headers: {
  //   "Content-Type":"multipart/form-data",
  //   "accept": "multipart/form-data"
  // }
  // timeout: 60000,
  // httpsAgent: new https.Agent({  
  //   rejectUnauthorized: false
  // })
});

service.interceptors.request.use(
  (config) => {   
    start = Date.now();    
    surl = config.url;
    let token = store.state.token;
      if(token)
        config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {     
    // 20240320, 回應時, 支援HSTS
    response.headers['Strict-Transport-Security'] = 'max-age=63072000; includeSubDomains; preload';
    const millis = Date.now() - start;
    // console.log(` ${surl} 載入時間 = ${Math.floor(millis / 1000 )}`);
    const res = response.data;
    return res;
  },
  (error) => {
    console.log(error);
    const { response } = error;
    store.dispatch('loadingHandler', false);
    if (response) {
      errorHandle(response.status, response.data.error, response);
      return Promise.reject(error);
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000,
      });
      return Promise.reject(error);
    }
  }
);

/* 錯誤捕捉 */
const errorHandle = (status, msg, response) => {
  switch (status) {
    case 400:
      break;

    case 401:
      tokenExpire();
      break;

    case 403:
      break;

    case 404:
      router.replace({
        name: '404',
      });
      break;

    case 500:
      break;

    default:
      break;
  }
};

const tokenExpire = () => {
  Message({
    message: '登入逾時，請重新登入！',
    type: 'error',
    duration: 3000,
  });
  /* 登出api */
  store.dispatch('Logout');
  router.replace({
    name: 'login',
  });
};

export default service;
